import { getDays, getHours, getMinutes, getSeconds } from '@core/shared';
import { useAppSelector } from '@online-webinar/store';
import { useTranslation } from 'react-i18next';

export const CountDownTime = () => {
    const remainingTimeToStart = useAppSelector((state) => state.liveWebinar.remainingTimeToStart);
    const { t } = useTranslation();

    if (remainingTimeToStart === null) {
        return null;
    }

    return (
        <div className="countdown-timer">
            <div className="flex gap-2 items-start justify-center font-light text-4xl md:text-5xl" role="timer" aria-atomic="true" aria-live="polite">
                {getDays(remainingTimeToStart) !== '0' && (
                    <>
                        <div className="flex flex-col">
                            <div className="flex [&>span]:w-[.6667em]">
                                {getDays(remainingTimeToStart)
                                    .split('')
                                    .map((dayNumber, index) => (
                                        <span key={`day-${index}`}>{dayNumber}</span>
                                    ))}
                            </div>
                            <span className="text-base">{t('Generic.Days')}</span>
                        </div>
                        <div className="text-075em mt-[.075em]">:</div>
                    </>
                )}
                <div className="flex flex-col items-center">
                    <div className="flex [&>span]:w-[.6667em]">
                        {getHours(remainingTimeToStart)
                            .split('')
                            .map((hourNumber, index) => (
                                <span key={`hour-${index}`}>{hourNumber}</span>
                            ))}
                    </div>
                    <span className="text-base">{t('Generic.Hour')}</span>
                </div>
                <div className="text-075em mt-[.075em]">:</div>
                <div className="flex flex-col items-center">
                    <div className="flex [&>span]:w-[.6667em]">
                        {getMinutes(remainingTimeToStart)
                            .split('')
                            .map((minuteNumber, index) => (
                                <span key={`minute-${index}`}>{minuteNumber}</span>
                            ))}
                    </div>
                    <span className="text-base">{t('Generic.Minute')}</span>
                </div>
                <div className="text-075em mt-[.075em]">:</div>
                <div className="flex flex-col items-center">
                    <div className="flex [&>span]:w-[.6667em]" {...(remainingTimeToStart > 10000 && { 'aria-hidden': 'true' })}>
                        {getSeconds(remainingTimeToStart)
                            .split('')
                            .map((secondNumber, index) => (
                                <span key={`second-${index}`}>{secondNumber}</span>
                            ))}
                    </div>
                    <span className="text-base" aria-hidden="true">
                        {t('Generic.Second')}
                    </span>
                </div>
            </div>
        </div>
    );
};
